import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject, forkJoin, map, takeUntil } from 'rxjs';
import { FormErrorHandler } from '../../../helpers/form-error-handler.helper';
import { AppMainComponent } from 'src/app/app.main.component';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { uploadFiles, validateFiles } from 'src/app/shared/upload-files';
import { TaskDataService } from '../../../stores/taskDataStore/taskData.service';
import { SharedChannelService } from '../../../services/channel.service';
import { AccountModuleId, CaseModuleId, LeadModuleId, OpportunityModuleId } from '../../../constants/modules.constant';
import { ChannelN } from '../../../models/channel.model';
import { TaskCategoryService } from 'src/app/shared/api/api';
import { ReminderType } from '../../../model/reminderType.model';
import { SharedTaskService } from 'src/app/shared/shared-task/shared-task.service';
import { Stage } from '../../shared-contacts/model/stage';
import { AppRuleSelectionService } from '../../rule-selection/app.rule.selection.service';
import { TaskPayload } from '../../../models/create-task/create-task.model';
import * as saveAs from 'file-saver';
import { GroupTaskEditPayload, TaskEditPayload } from '../../../models/create-task/task-edit-model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ColumnSettingsN } from '../../../models/column-settings.model';
import { ParseHelper } from '../../../parse.helper';
import { SharedColumnSettingsService } from '../../../services/column-settings.service';
import { Listbox } from 'primeng/listbox';
import { TaskType } from '../../../enums/task.enum';
import { startDateLessThanEndDateValidator } from '../../../validators/startdate-lessthan-enddate.validator';
import { TimeZoneService } from '../../../services/timezone.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-shared-create-task',
  templateUrl: './shared-create-task.component.html',
  styleUrls: ['./shared-create-task.component.scss']
})
export class SharedCreateTaskComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    //Input properties
    @Input() displayAddEditDialog: boolean = false;
    @Input() taskEditId: number = 0;
    @Input() taskViewOnly: boolean = false;
    @Input() objectId: number = 0;
    @Input() headerTitle: string = "Add New Task";
    @Input() isCopyTask: boolean = false;
    @Input() selectedTaskId: number = 0;

    //create Task From Module
    @Input() moduleId: number = 0; //objectTypeId
    @Input() taskFromModule: boolean = false;
    @Input() selectedObject: any;

    //Output properties
    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() loadNewList = new EventEmitter<boolean>();
    @Output() cancelClicked = new EventEmitter();
    @Output() onCreateComplete = new EventEmitter();

    //Create task details form
    taskDetailsForm: FormGroup = new FormGroup({});
    groupTaskDetailsForm: FormGroup = new FormGroup({});
    checkListForm: FormGroup = new FormGroup({});
    addTaskCategoryForm: FormGroup = new FormGroup({});;
    loadingTaskSave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    // Boolean variable
    displayAddEditList: boolean = false;
    displayAddTaskCategory: boolean = false;
    showAddMore: boolean = false;
    taskOrder: boolean = false
    //enums
    taskType  = TaskType.Individual;
    checkList: any = [];
    checklistHeader: string;
    minimumDate = new Date();
    taskEditDetails: any;
    taskFeildData: any;
    @ViewChild('editor') editor: any;
    @ViewChild('listbox') listbox: Listbox;

    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.txt', '.csv'];
    multiLineTooltip = `<ul class="p-mt-0 p-pl-4 p-mb-0">
    <li>Files with extensions: doc, docx, pdf, xls, xlsx, txt, gif, jpeg are allowed</li>
  </ul> `;
    mimeTypes = [
      { extension: "csv", value: "text/csv;charset=utf-8" },
      { extension: "doc", value: "application/msword;charset=utf-8" },
      { extension: "docx", value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" },
      { extension: "gif", value: "image/gif;charset=utf-8" },
      { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
      { extension: "jpg", value: "image/jpeg;charset=utf-8" },
      { extension: "png", value: "image/png;charset=utf-8" },
      { extension: "pdf", value: "application/pdf;charset=utf-8" },
      { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
      { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
      { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
      { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
      { extension: "zip", value: "application/zip;charset=utf-8" },
      { extension: "txt", value: "text/plain;charset=utf-8" }
    ];
    uploadedFiles: any[] = [];
    //dropdown values
    activeUsers: any[] = [];
    sharedTaskWith: any[] = [];
    taskModules: any[] = [];
    channelsN: ChannelN[] = [];
    stages: Stage[] = [];
    allAssociationNamesList: any[] = [];
    associationNames: any[] = [];
    taskCategories: any[] = [];
    reminderTypes: ReminderType[] = [];
    reminderDelay: any[] = [];
    repeat: any[] = [];
    priority: any[] = [];

    //#region GroupTaskFeilds
    displayGroupTaskList: boolean = false;   //displayAddEditList2
    checklistHeader2;
    selectedGroupTaskUser: any = null;
    today = new Date();
    cleanText = '';
    groupAllTaskList: any[] = [] //taskMulti
    groupTaskIndex: any;
    groupTaskCheckListIndex: any;
    TaskType = TaskType;
    appComponent:any;
    // assignTo User pop-up
    selectedReassignUser:any[] = [];
    displayUsers:boolean = false;
    isAssignToSingleOrMulti: boolean = false; //set condition for assignTo  is multiselect or single select
    @Input() isAddTask: boolean = false;
    defaultTaskFeildsValues: any = {};

    constructor(
      private formBuilder: FormBuilder,
      private app: AppMainComponent,
      private messageService: MessageService,
      private appMainService: AppMainService,
      private dataService: TaskDataService,
      private channelService: SharedChannelService,
      private taskCategoryService: TaskCategoryService,
      private taskService: SharedTaskService,
      private ruleService: AppRuleSelectionService,
      private columnSettingsService: SharedColumnSettingsService,
      private timezoneService: TimeZoneService,
      private sanitizer: DomSanitizer,
      private confirmationService: ConfirmationService,
    ) { }

    ngOnInit(): void {
      this.appComponent = this.app;
      this.initTaskDetailsForm();
      this.initAddGroupTaskDetailsForm();
      this.onTaskTypeChange();
      this.loadInitialData();
      this.initCheckListForm();
      this.showAddTask();
    }
    //#region *NgOnChanges*
    ngOnChanges(changes: SimpleChanges): void {
      if (changes?.headerTitle?.currentValue) {
        this.headerTitle = changes.headerTitle.currentValue;
      }

      if (changes?.displayAddEditDialog?.currentValue) {
        this.displayAddEditDialog = changes.displayAddEditDialog.currentValue;
      }

      if (changes?.taskFromModule?.currentValue) {
        this.taskFromModule = changes.taskFromModule.currentValue;
      }

      if (changes?.moduleId?.currentValue) {
        this.moduleId = changes.moduleId.currentValue;
      }

      if (changes?.selectedObject?.currentValue) {
        this.selectedObject = changes.selectedObject.currentValue;
      }

      if (changes?.taskEditId?.currentValue) {
        this.taskEditId = changes.taskEditId.currentValue;
        this.populateTaskData(this.taskEditId);
      }
      if (changes?.isCopyTask?.currentValue && changes?.selectedTaskId?.currentValue) {
        this.selectedTaskId = changes?.selectedTaskId?.currentValue
        this.populateTaskData(this.selectedTaskId);
      }
      if (changes?.isAddTask?.currentValue) {
        this.isAddTask = changes.isAddTask.currentValue;
      }
    }

    //#endregion *NgOnChanges*

    //#region TaskReactiveFrom
    initTaskDetailsForm() {
      this.detailsFormErrors = {};
      this.isUnsavedData = false;
      this.taskDetailsForm = this.formBuilder.group({
        id: [0],
        restrictNotifications:[false],
        startDateTime: [null, Validators.required],
        endDateTime: [null, Validators.required],
        assignedTo: [null],
        relatedTo: [null],
        channelId: [null],
        association: [null],
        sharedUsers: [null],
        taskCategoryId: [null, Validators.required],
        stages: [null],
        taskTitle: [null],
        taskDetails: [null],
        checklist: this.formBuilder.array([
        ]),
        attachmentLinks: this.formBuilder.array([]),
        reminderTypeId: [null],
        reminderDelay: [null],
        taskRepeat: [null],
        priorityId: [null]
      }, { validator: startDateLessThanEndDateValidator('startDateTime', 'endDateTime') });

      this.setModuleDetails();

      this.formErrorHandler.handleErrors(this.taskDetailsForm, this.detailsFormErrors, {
        startDateTime: {
          required: 'Task Start date is required'
        },
        endDateTime: {
          required: 'Task Due date is required'

        },
        assignedTo: {
          required: "Task assign-to is required",
        },
        taskCategoryId: {
          required: "Task Category is required",
        }
      });
    }

    setModuleDetails(){
        if(this.taskFromModule && this.selectedObject){
            const selectedAssociation =  [{id:  this.selectedObject?.id, businessName:  this.selectedObject?.businessName||this.selectedObject?.name || this.selectedObject?.associationName
            }];
            const channelId: number = this.selectedObject?.typeId||this.selectedObject?.pipelineId|| this.selectedObject?.channelId || 0;
            this.taskDetailsForm.patchValue({
                relatedTo: this.moduleId,
                channelId: channelId,
                association: selectedAssociation
            });
            this.taskDetailsForm.get('relatedTo').disable();
            this.taskDetailsForm.get('channelId').disable();
            this.onChangeModule(this.moduleId);
            this.associationNames = selectedAssociation;
            // this.onChangeChannel(channelId);
        } else if (this.moduleId) {
          this.taskDetailsForm.patchValue({
            relatedTo: this.moduleId,
          });
          this.onChangeModule(this.moduleId);
        }
    }

    initCheckListForm() {
      this.checkListForm = this.formBuilder.group({
        description: [''],
        checkListIndex: [-1],
        isMarkedCompleted: [false]
      });
    }

    initAddTaskCategoryForm() {
      this.detailsFormErrors = {};
      this.addTaskCategoryForm = this.formBuilder.group({
        categoryName: [null, [Validators.required , Validators.maxLength(50)]]
      });
      this.formErrorHandler.handleErrors(this.addTaskCategoryForm, this.detailsFormErrors, {
        categoryName: {
          required: 'Category name is required',
          maxlength: "Category name cannot exceed 50 characters"
        },

      });
    }

    loadChecklistFormGroup(): FormGroup {
      return this.formBuilder.group({
        description: [''],
        isCheck: [false],
        statusId: [1],
        id: [0]
      });
    }
    //#endregion TaskReactiveFrom

    showAddTask(){
      this.showAddMore = false;
      let endDate = new Date(new Date().getTime() + 6 * 24 * 60 * 60 * 1000);
      let startDate = this.app._showDateTimeWithZone(new Date());
      this.minimumDate = this.app._showDateTimeWithZone(new Date())
      let endDateTime = this.app._showDateTimeWithZone(endDate);
      this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
      this.sharedTaskWith = this.app.usersList.filter(obj => obj.statusId == 1);
      this.taskDetailsForm.patchValue({
        startDateTime: startDate,
        endDateTime: endDateTime
      });
    }

    // #region Checklist-AddEdit
    addList(taskIndex?: number) {
      this.groupTaskIndex = taskIndex  //groupTaskIndex:-ForGroupTaskAddEdit
      this.initCheckListForm();
      this.checklistHeader = "Add checklist";
      this.displayAddEditList = true;
    }

    editCheckList(index: number, checkListIndex?: number){
      this.groupTaskIndex = index;
      this.groupTaskCheckListIndex = checkListIndex
      this.checklistHeader = "Edit checklist";
      if (this.taskType == TaskType.Individual) {
        const checklistItem = (<FormArray>this.taskDetailsForm.get('checklist')).at(index).value;
        this.checkListForm.patchValue({
          description: checklistItem.description,
          checkListIndex: index,
          isMarkedCompleted: checklistItem.isCheck
        });
      } else {
        const checklistItem = this.groupAllTaskList[this.groupTaskIndex].groupTaskChecklist[checkListIndex];
        this.checkListForm.patchValue({
          description: checklistItem.description,
          checkListIndex: checkListIndex,
          isMarkedCompleted: checklistItem.isCheck
        });
      }

      this.displayAddEditList = true;
    }

    saveList(){
      const checkListFormValue = this.checkListForm.getRawValue();
      if (this.taskType == TaskType.Individual) {
        this.handleIndividualTask(checkListFormValue);
      } else {
        this.handleGroupTask(checkListFormValue, this.groupTaskCheckListIndex);
      }
      this.displayAddEditList = false;
    }

    handleIndividualTask(checkListFormValue: any){
      const checklistArray = <FormArray>this.taskDetailsForm.get('checklist');
      const checklistItem = this.formBuilder.group({
        description: [checkListFormValue.description],
        isCheck: [checkListFormValue.isMarkedCompleted],
        statusId: [1]
      });
      if (checkListFormValue.checkListIndex === -1) {
        // Add new item
        checklistArray.push(checklistItem);
      } else {
        // Edit existing item
        const index = checkListFormValue.checkListIndex;
        checklistArray.at(index).patchValue({
          description: checkListFormValue.description,
          isCheck: checkListFormValue.isMarkedCompleted,
          statusId: 1
        });
      }
    }

    handleGroupTask(checkListFormValue: any, groupTaskCheckListIndex: any){
      const data = {
        description: checkListFormValue.description,
        isCheck: checkListFormValue.isMarkedCompleted,
      };
      if (this.groupTaskIndex > -1 && this.groupAllTaskList[this.groupTaskIndex]) {
        const groupTaskChecklist = this.groupAllTaskList[this.groupTaskIndex].groupTaskChecklist;
        if (checkListFormValue.checkListIndex === -1) {
          // Add new item
          groupTaskChecklist.push(data);
        } else {
          // Edit existing item
          const index = checkListFormValue.checkListIndex;
          groupTaskChecklist[index] = {
            ...groupTaskChecklist[index],
            description: checkListFormValue.description,
            isCheck: checkListFormValue.isMarkedCompleted,
          };
        }
      }
    }

    removeCheckList(index: number, checkListIndex?: number){
      if (this.taskType == TaskType.Individual) {
        (<FormArray>this.taskDetailsForm.get('checklist')).removeAt(index);
      }
      else
        if (index > -1 && this.groupAllTaskList[index]) {
          const groupTaskChecklist = this.groupAllTaskList[index].groupTaskChecklist;
          if (checkListIndex !== undefined && checkListIndex > -1 && checkListIndex < groupTaskChecklist.length) {
            groupTaskChecklist.splice(checkListIndex, 1);
          }
        }
    }

    //#region ***Attachments***
    get attachments(): FormArray{
      return <FormArray>this.taskDetailsForm.controls.attachmentLinks;
    }

    downloadFile(name: string, content: string, locationUrl: string){
      let ext = name.substring(name.lastIndexOf('.') + 1);

      let mime_type = this.mimeTypes.filter(el => el.extension === ext);
      if (mime_type.length > 0 && content) {
        const base64 = content;
        const mime = mime_type[0].value;
        const blob = this.dataURItoBlob(base64, mime);
        const file = new File([blob], name, { type: mime });
        saveAs(file, name)
      } else {
        window.open(locationUrl);
      }
    }

    dataURItoBlob(dataURI: string, mimeType: string){
      const kept = dataURI.split(",", 2);
      const byteString = atob(kept[1]);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: mimeType });
      return blob;
    }


    removeAttachment(data){
      let removableIndex = this.uploadedFiles.indexOf(data);
      if (removableIndex >= 0) {
        this.uploadedFiles.splice(removableIndex, 1);
        this.attachments.removeAt(removableIndex);
      }
    }

    uploadAttachments(files: File[]){
      this.appMainService.isShowSpinner('upload');
      if (typeof Worker !== undefined) {
        //  let errors = validateTotalFileSize(files, 25);
        for (let file of files) {
          if (file.size > 2 * 1024 * 1024) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: file.name + ":File size exceeds the 2MB limit.Please upload a smaller file."
            });
            this.appMainService.isHideSpinner('upload');
        } else {
          let errors = validateFiles(file, 25, this.allowedExtensions);
          if (errors.length > 0) {
            for (let error of errors) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.fileName + ": " + error.error
              });
            }
            this.appMainService.isHideSpinner('upload');
          } else {
            // this.newFileList.push(file);
            uploadFiles(file, ({ name, content, size, extension }) => {
              let attachmentObj: any = {
                "attachmentId": 0,
                "name": name,
                "guidName": "string",
                "location": "string",
                "content": content,
                "extension": extension,
                "sizeInBytes": size,
                "id" : 0
              };
              this.uploadedFiles.push(attachmentObj);
              this.attachments.push(this.formBuilder.group(attachmentObj));
              this.appMainService.isHideSpinner('upload');
            });
          }
        }
      }
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "Please update the browser. Web Workers are not supported in the older versions of this browser." });
      }

    }

    //#endregion

    //#region ***Dropdowns***
    loadInitialData(){
        this.getTaskCategories();
        this.getModules();
        this.getReminderTypes();
        this.getReminderDelay();
        this.getTaskRepeat();
        this.getTaskPriority();
    }

    getModules(): void{
      this.taskService.getTaskModules().subscribe({
        next: (response) => {
          this.taskModules =  response ?? [] ;
        },
        error: (error) => {
        }
      })
    }

    onChangeModule(moduleId: number, clearData: boolean = false): void{
        this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);

        if(clearData){
            this.associationNames = [];
            this.taskDetailsForm.patchValue({
                channelId: null,
                association: null,
                stages: null
            });
        }

        switch (moduleId) {
            case LeadModuleId:
            case AccountModuleId:
                this.getLeadAccountChannel(moduleId);
            break;
            case OpportunityModuleId:
                this.getOpportunityCasesChannel(moduleId);
            break;
            case CaseModuleId:
                this.getCaseChannel(moduleId);
            break;
            default:
            break;
        }
    }

    getLeadAccountChannel(objectId: number){
      this.appMainService.isShowSpinner('getChannel');
      this.channelService.getChannels(objectId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          {
            next: (response) => {
              this.channelsN = response || [];
              this.appMainService.isHideSpinner('getChannel');
            },
            error: (error) => {
              this.appMainService.isHideSpinner('getChannel');
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
              });

            },
            complete: () => {
            },
          });
    }

    getOpportunityCasesChannel(objectId: number){
      this.appMainService.isShowSpinner('getChannel')
      this.channelService.getAllChannels(objectId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          {
            next: (response) => {
              this.channelsN = response || [];
              this.appMainService.isHideSpinner('getChannel');
            },
            error: (error) => {
              this.appMainService.isHideSpinner('getChannel');
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
              });

            },
            complete: () => {
            },
          });
    }

    getCaseChannel(objectId: number){
      this.appMainService.isShowSpinner('getChannel');
      this.channelService.getAllChannels(objectId)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          {
            next: (response) => {
              this.channelsN = response || [];
              this.appMainService.isHideSpinner('getChannel');
            },
            error: (error) => {
              this.appMainService.isHideSpinner('getChannel');
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
              });

            },
            complete: () => {
            },
          });
    }

    onChangeChannel(channelId: number, clearData: boolean = false){
        //this.getStages();
        this.getAssociationNames();
        if(clearData){
            this.associationNames = [];
            this.taskDetailsForm.patchValue({
                association: null,
                stages: null
            });
        }

        // this.channelService.getChannelWiseUsers(channelId, this.taskDetailsForm.value.relatedTo).subscribe({
        //     next: (data: any[]) => {
        //         this.activeUsers =  data?.length>0 ? data.filter(obj => obj.statusId == 1) : [];
        //     },
        //     error: (err) => {}
        // })
    }

    getStages() {
      const moduleId = this.taskDetailsForm.get('relatedTo').value;
      const selectedChannel = this.taskDetailsForm.get('channelId').value;

      if((moduleId === LeadModuleId || moduleId === OpportunityModuleId || moduleId === CaseModuleId) && selectedChannel){
        this.ruleService
        .getStageList(moduleId, selectedChannel, true)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((stages) => {
          if (stages) {
            this.stages = stages;
            this.taskDetailsForm.get('stages')?.setValue(this.stages[0].id);
          }
        });
      }
    }

    getReminderTypes() {
      this.dataService.loadReminderTypes()
        .pipe(map((reminderTypes: ReminderType[]) => {
          this.reminderTypes = reminderTypes;
          this.reminderTypes = this.reminderTypes?.length ? this.reminderTypes.slice(1, this.reminderTypes?.length) : [];
          const reminderType = this.reminderTypes?.length ? this.reminderTypes[0].id : null;
          this.taskDetailsForm.get('reminderTypeId').setValue(reminderType);
          this.taskDetailsForm.get('reminderTypeId').disable();

        }))
        .subscribe();
    }

    getReminderDelay() {
      this.taskService.getReminderDelays().then(delays => {
        this.reminderDelay = delays;
        if(this.taskEditId <= 0){
          this.taskDetailsForm.get('reminderDelay').setValue(delays[0]?.value);
        }
       
      });
    }

    getTaskRepeat() {
      this.repeat = this.app.eventRepeatType;
      const selectedTaskRepeat = this.repeat && this.repeat.length > 0 ? this.repeat[0]?.id : null;
      if(this.taskEditId <= 0){
        this.taskDetailsForm.get('taskRepeat').setValue(selectedTaskRepeat);
      }
      
    }

    getTaskPriority() {
      this.appMainService.isShowSpinner('priority');
      this.taskService.allTaskPriorityList().subscribe({
        next: (response) => {
        this.priority = response;
        this.getTaskFeildsAndDefaultValues();   
        this.appMainService.isHideSpinner('priority');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('priority');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ?? 'Something went wrong'
          });
        }
      })
  
    }

    getTaskCategories(): void {
      this.taskCategoryService.getTaskActiveCategoryGet().subscribe({
        next: (resp: any) => {
          this.taskCategories = resp;
          this.updateTaskCategory();

        }
      })
    }

    updateTaskCategory(){
      if(this.taskCategories.length > 0 && this.taskEditDetails){
        const validCategory = this.taskCategories.some(category => category.id === this.taskEditDetails?.task?.taskCategoryId);
        this.taskDetailsForm.patchValue({
          taskCategoryId: validCategory ? this.taskEditDetails?.task?.taskCategoryId : null,
         
        })
      }
    }

    //#endregion ***End Dropdowns***

    addNewCategory(e) {
      this.displayAddTaskCategory = true;
      this.initAddTaskCategoryForm();
    }

    resetFormFields(): void {
      this.associationNames = [];
      this.taskDetailsForm.get('channelId').reset();
      this.taskDetailsForm.get('association').reset();
      this.taskDetailsForm.get('assignedTo').reset();
      this.taskDetailsForm.get('stages').reset();
    }

    //#region ***Association**

    getAssociationNames(query: string = "") {
      const values = this.getFormControlValues();
      if (values?.relatedTo > 0 && values?.channelId > 0) {
        query = query?.trim()||"";
        switch (values?.relatedTo) {
          case LeadModuleId:
            // this.getLeadNameListUserWise(query);
            break;
          case AccountModuleId:
            // this.getAccountNameListUserWise(query);
            break;
          case OpportunityModuleId:
            this.getOpportunityNameListUserWise(query);
            break;
          case CaseModuleId:
            this.getCasesNameListUserWise(query);
            break;
          default:
            break;
        }
      }
    }

    getLeadNameListUserWise(query, userId) {
      const values = this.getFormControlValues();
      this.channelService.getLeadNameListUserWise(query, values?.channelId, userId).subscribe({
        next: (response: any) => {
            this.associationNames = response?.length>0 ? response.map(item => ({ id: item.id, businessName: item.name })) : [];
        }
      })
    }

    getAccountNameListUserWise(query, userId) {
      const values = this.getFormControlValues();
      this.channelService.getAccountNameListUserWise(query, values?.channelId, userId).subscribe({
        next: (response: any) => {
            this.associationNames = response?.length>0 ? response.map(item => ({ id: item.id, businessName: item.name })) : [];
        }
      })
    }

    getCasesNameListUserWise(query: string) {
      const values = this.getFormControlValues();
      let requestModel: any = {
        channelId: values?.channelId,
        accountChannelId: null,
        stageId: null,
        isActive: true,
        globalSearchValue: query||"",
        selectableColumns: [{
          columnName: "sequenceNumber",
          isCustom: false
        }],
        filter: null,
        pageSize: 0,
        pageNumber: 0,
        sortByColumn: null,
        isSortByDescending: true,
        filterInColumns: []
      }
      this.channelService.getCasesNameListUserWise(this.app.userId, requestModel).subscribe({
        next: (response: any) => {
            this.associationNames = response?.list?.length>0 ? response.list.map(item => ({ id: item.id, businessName: item.sequenceNumber })) : [];
            const association = this.taskDetailsForm.getRawValue().association;
            const exist = this.associationNames.find(a=> a.id==association?.id);
            if(association && !exist){
                this.associationNames = [association, ...this.associationNames];
            }
        }
      })
    }

    getOpportunityNameListUserWise(query: string) {
      const values = this.getFormControlValues();
      this.channelService.getOpportunityNameListUserWise(query||"", values?.channelId,this.app.userId).subscribe({
        next: (response: any) => {
            this.associationNames = response?.length>0 ? response.map(item => ({ id: item.id, businessName: item.name })) : [];
            const association = this.taskDetailsForm.getRawValue().association;
            const exist = this.associationNames.find(a=> a.id==association?.id);
            if(association && !exist){
                this.associationNames = [association, ...this.associationNames];
            }
        }
      })
    }

    //#endregion Association

    cancelNewTask(iscreated?) {
      this.showAddMore = false;
      this.displayAddEditDialog = false;
      this.taskDetailsForm.reset();
      if (iscreated) {
        this.onCreateComplete.emit({});
      } else {
        this.cancelClicked.emit({});
      }
    }

    getFormControlValues() {
      return {
        relatedTo: this.taskDetailsForm.get('relatedTo')?.value,
        channelId: this.taskDetailsForm.get('channelId')?.value,
      };
    }

    //#region ***Save Task Methods***
    onSaveTask() {
      let taskPayload: any;
      if (this.taskType == TaskType.Group && (!this.groupAllTaskList || this.groupAllTaskList.length < 1)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Task is not created. Please create or add at least one task to the group.'
        });
        return; // Prevent saving if validation fails
      }
      if (this.taskDetailsForm.invalid) {
        this.formErrorHandler.showErrorOnSubmit();
        this.scrollToError();
        return; //Return if form invalid
      }
      this.appMainService.isShowSpinner('SaveNewTask');

      if (this.taskEditId > 0) {
        let taskEditPayload: any;
        if (this.taskType == TaskType.Individual) {
          taskEditPayload = this.prepareIndividualTaskEditPayloadData();
        } else {
          taskEditPayload = this.prepareGroupTaskEditPayloadData();
        }
        if (taskEditPayload) {
          this.taskService.updateTask(taskEditPayload).subscribe({
            next: (response) => {
              this.appMainService.isHideSpinner('SaveNewTask');
              this.loadingTaskSave = false;
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Task Updated Successfully'
              });
              this.loadNewList.emit(true);
              this.cancelNewTask();
            },
            error: (error) => {
              this.appMainService.isHideSpinner('SaveNewTask');
              this.loadingTaskSave = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.message ? error?.error?.message : 'Failed To Update The Task'
              });
            }
          })
        }
      } else {

        if (this.taskType == TaskType.Individual) {
          taskPayload = this.prepareIndividualTaskAddPayloadData();
        } else {
          taskPayload = this.prepareGroupTaskAddPayloadData();
        }

        if (taskPayload) {
          this.taskService.newAddTask(taskPayload).subscribe({
            next: (response) => {
              this.appMainService.isHideSpinner('SaveNewTask');
              this.loadingTaskSave = false;
              if (this.isCopyTask) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Task Copied successfully...',
                });
              } else {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Task Created Successfully'
                });
              }
              this.loadNewList.emit(true);
              this.cancelNewTask(true);
            },
            error: (error) => {
              this.appMainService.isHideSpinner('SaveNewTask');
              this.loadingTaskSave = false;
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.error?.message ? error?.error?.message : 'Failed To Create New Task'
              });
            }
          })
        }

      }

    }

    // Scroll to error handler function
    scrollToError(): void {
      const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
      this.scrollTo(firstElementWithError);
      if (!firstElementWithError) {
        const secondElementWithError = document.querySelector('.p-invalid');
        this.scrollTo(secondElementWithError);
      }
    }
    // Scroll to error element
    scrollTo(el: Element): void {
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    //#endregion ***Save Task Methods***


    //#region I&G all Payload
    prepareIndividualTaskAddPayloadData(): TaskPayload {
      const taskFromValues = this.taskDetailsForm.getRawValue();
      const taskUsers = (taskFromValues.assignedTo || []).map((userId: any) => ({
        userId: userId?.id,
        sharedUserId: taskFromValues.sharedUsers,
        description: ""
      }));
      const selectedAssociation: any = taskFromValues.association?.length > 0 ? taskFromValues.association.map(item => item.id) : [];
      const taskPayload: TaskPayload = {
        restrictNotifyCreateBy : taskFromValues?.restrictNotifications,
        objectIds: selectedAssociation,
        objectTypeId: taskFromValues?.relatedTo || null,
        channelId: taskFromValues.channelId || null,
        task: {
          taskTypeId: this.taskType,
          name: taskFromValues?.taskTitle,
          description: taskFromValues.taskDetails,
          taskCategoryId: taskFromValues.taskCategoryId || null,
          priorityId: taskFromValues.priorityId || null,
          startDateTime: this.timezoneService.saveDateTimeWithZone(taskFromValues.startDateTime).toISOString(),
          endDateTime: this.timezoneService.saveDateTimeWithZone(taskFromValues.endDateTime).toISOString(),
          taskAttachments: taskFromValues?.attachmentLinks?.map((attachment: any) => ({
            attachmentId: attachment.attachmentId || 0,
            attachment: {
              name: attachment.name,
              guidName: attachment.guidName,
              location: attachment.location,
              content: attachment.content,
              extension: attachment.extension,
              sizeInBytes: attachment.sizeInBytes
            }
          })) || null,
          taskUsers: taskUsers,
          reminderTypeId: taskFromValues.reminderTypeId,
          taskStatuses: null,
          taskCalendarEvents: [{
            calendarEventId: 0,
            calendarEvent: {
              name: taskFromValues?.taskTitle,
              description: taskFromValues.taskDetails,
              startDate: taskFromValues.startDateTime,
              endDate: taskFromValues.endDateTime,
              locationId: null,
              reminderInMinutes: taskFromValues?.reminderDelay,
              userId: this.app.user?.userId,
              isAllDay: false,
              isRecurring: true,
              repeatTypeId: taskFromValues.taskRepeat,
              occurrences: [{
                dayOfWeek: null,
                weekOfMonth: null,
                dayOfMonth: null,
                monthOfYear: null,
                maxNoOfOccurrence: null,
                separationCount: null,
                isValid: true
              }]
            }
          }],
          taskCheckLists: taskFromValues.checklist?.map((checkList: any) => ({
            description: checkList.description,
            isCheck: checkList.isCheck,
            statusId: checkList?.statusId
          })) || null
        },
        stageIds: taskFromValues?.stages &&  taskFromValues.association?.id ? [taskFromValues?.stages] : null
      };

      return taskPayload;
    }

    prepareGroupTaskAddPayloadData(): TaskPayload {
      const taskFromValues = this.taskDetailsForm.getRawValue();
      const selectedAssociation: any = taskFromValues.association?.length > 0 ? taskFromValues.association.map(item => item.id) : [];
      const taskPayload: TaskPayload = {
        restrictNotifyCreateBy : taskFromValues?.restrictNotifications,
        objectIds: selectedAssociation,
        objectTypeId: taskFromValues?.relatedTo || null,
        channelId: taskFromValues.channelId || null,
        task: {
          sharedUserId: taskFromValues.sharedUsers,
          taskTypeId: this.taskType,
          name: taskFromValues?.taskTitle,
          description: taskFromValues.taskTitle,
          taskCategoryId: taskFromValues.taskCategoryId || null,
          priorityId: taskFromValues.priorityId || null,
          startDateTime: this.timezoneService.saveDateTimeWithZone(taskFromValues.startDateTime).toISOString(),
          endDateTime: this.timezoneService.saveDateTimeWithZone(taskFromValues.endDateTime).toISOString(),
          taskAttachments: taskFromValues?.attachmentLinks?.map((attachment: any) => ({
            attachmentId: attachment.attachmentId || 0,
            attachment: {
              name: attachment.name,
              guidName: attachment.guidName,
              location: attachment.location,
              content: attachment.content,
              extension: attachment.extension,
              sizeInBytes: attachment.sizeInBytes
            }
          })) || null,
          taskUsers: null,
          reminderTypeId: taskFromValues.reminderTypeId,
          taskStatuses: null,
          taskCalendarEvents: [{
            calendarEventId: 0,
            calendarEvent: {
              name: taskFromValues?.taskTitle,
              description: taskFromValues?.taskTitle,
              startDate: this.timezoneService.saveDateTimeWithZone(taskFromValues.startDateTime).toISOString(),
              endDate: this.timezoneService.saveDateTimeWithZone(taskFromValues.endDateTime).toISOString(),
              locationId: null,
              reminderInMinutes: taskFromValues?.reminderDelay,
              userId: this.app.user?.userId,
              isAllDay: false,
              isRecurring: true,
              repeatTypeId: taskFromValues?.taskRepeat,
              occurrences: [{
                dayOfWeek: null,
                weekOfMonth: null,
                dayOfMonth: null,
                monthOfYear: null,
                maxNoOfOccurrence: null,
                separationCount: null,
                isValid: true
              }]
            }
          }],
          taskCheckLists: null,
          taskOrder: this.taskOrder,
          childTask: this.groupAllTaskList?.map((childTask: any, index: number) => ({
            startDateTime: this.timezoneService.saveDateTimeWithZone(childTask?.startDate),
            endDateTime: this.timezoneService.saveDateTimeWithZone(childTask?.endDate),
            description: childTask?.description,
            order: index,
            taskUsers: childTask?.assignTo?.id,
            taskCheckLists: childTask?.groupTaskChecklist
          })) || null,
        },
        stageIds: taskFromValues?.stages ? [taskFromValues?.stages] : null
      };

      return taskPayload;

    }

    prepareIndividualTaskEditPayloadData(): TaskEditPayload {
      const taskFromValues = this.taskDetailsForm.getRawValue();
      const selectedAssociation: any = taskFromValues.association?.length > 0 ? taskFromValues.association.map(item => item.id) : [];
     
      const taskEditPayload: TaskEditPayload = {
        objectIds: selectedAssociation, // Assign default values or leave them as null
        objectTypeId: taskFromValues?.relatedTo || null,
        type: null,
        taskId: this.taskEditDetails?.taskId,
        task: {
          name: taskFromValues?.taskTitle,
          description: taskFromValues?.taskDetails,
          organizationId: this.taskEditDetails.task?.organizationId,
          taskCategoryId: taskFromValues.taskCategoryId || null,
          taskCategory: null,
          priorityId: taskFromValues.priorityId,
          startDateTime:  this.app._saveDateTimeWithZone(taskFromValues.startDateTime).toISOString(),
          endDateTime: this.app._saveDateTimeWithZone(taskFromValues.endDateTime).toISOString(),
          locationId: null,
          location: null,
          timeZoneId: null,
          timeZone: null,
          parentTaskId: null,
          statusId: 1,
          status: null,
          reminderTypeId: taskFromValues.reminderTypeId,
          reminderType: null,
          isValid: true,
          reAssignedDate: this.taskEditDetails?.task.reAssignedDate,
          reAssignedDescription: this.taskEditDetails?.task?.reAssignedDescription,
          reAssignedStatus: this.taskEditDetails?.task?.reAssignedStatus,
          validFromDate: null,
          validToDate: null,
          taskTypeId: this.taskType == TaskType.Individual ? 1 : 2,
          taskUsers: [{
            userId: taskFromValues.assignedTo[0]?.id,
            sharedUserId: taskFromValues.sharedUsers,
            taskId: this.taskEditDetails?.task?.taskId,
            id: this.taskEditDetails?.task.taskUsers[0]?.id,
            reAssignedUserId: this.taskEditDetails?.task.taskUsers[0]?.reAssignedUserId ?? null,
            createdSource: this.taskEditDetails?.task.taskUsers[0]?.createdSource,
            updatedSource: null,
            createdBy: this.taskEditDetails?.task.taskUsers[0]?.createdBy,
            updatedBy: null,
            createdDate: this.taskEditDetails?.task.taskUsers[0]?.createdDate,
            updatedDate: null,
            description: ''
          }],
          taskStatuses: null,
          taskCheckLists: this.taskDetailsForm.get('checklist').value?.map((checklistItem, index) => ({

            ...this.taskEditDetails?.task.taskCheckLists[index],
            description: checklistItem.description,
            isCheck: checklistItem.isCheck,
            statusId: 1,
            id: checklistItem.id
            ,
          })),
          taskCalendarEvents: this.taskEditDetails.task?.taskCalendarEvents?.map((event) => ({
            ...event,
            calendarEvent: {
              ...event.calendarEvent,
              reminderInMinutes: taskFromValues.reminderDelay ?? event.calendarEvent.reminderInMinutes,
              repeatTypeId: taskFromValues.taskRepeat ?? event.calendarEvent.repeatTypeId,
            }
          })) ?? null,
          taskAttachments: taskFromValues?.attachmentLinks?.map((attachment: any, index) => ({
            ...this.taskEditDetails.task.taskAttachments[index],
            attachmentId: attachment.attachmentId || 0,
            attachment: {
              name: attachment.name,
              location: attachment.location,
              sizeInBytes: attachment.sizeInBytes,
              content: attachment?.content,
              statusId: 1
            },
            id: attachment?.id || 0
          })) || null,
          createdByName: null,
          reminderDateTime: null,
          taskStage: null,
          channelName: null,
          moduleName: null,
          associationName: null,
          stageIds: null,
          taskTypeName: null,
          taskOrder: null,
          id: this.taskEditDetails?.taskId,
          createdSource: this.taskEditDetails?.task.createdSource,
          updatedSource: null,
          createdBy: this.taskEditDetails?.task.createdBy,
          updatedBy: null,
          createdDate: this.taskEditDetails?.task.createdDate,
          updatedDate: null
        },
        channelId: taskFromValues.channelId || null,
        stageId: null,
        stageName: null,
        stageIds: taskFromValues?.stages ? [taskFromValues?.stages] : null,
        id: this.taskEditDetails?.id,
        createdSource: this.taskEditDetails?.createdSource,
        updatedSource: null,
        createdBy: this.taskEditDetails?.createdBy,
        updatedBy: null,
        createdDate: this.taskEditDetails?.createdDate,
        updatedDate: null
      };
   

      return taskEditPayload
    }


    prepareGroupTaskEditPayloadData(): GroupTaskEditPayload {
      const taskFromValues = this.taskDetailsForm.getRawValue();
      const selectedAssociation: any = taskFromValues.association?.length > 0 ? taskFromValues.association.map(item => item.id) : [];
      const taskEditPayload: GroupTaskEditPayload = {
        objectIds: selectedAssociation, // Assign default values or leave them as null
        objectTypeId: taskFromValues?.relatedTo || null,
        type: null,
        taskId: this.taskEditDetails?.taskId,
        task: {
          name: taskFromValues?.taskTitle,
          description: taskFromValues?.taskTitle,
          organizationId: this.taskEditDetails.task?.organizationId,
          taskCategoryId: taskFromValues.taskCategoryId || null,
          taskCategory: null,
          priorityId: taskFromValues.priorityId,
          startDateTime: this.app._saveDateTimeWithZone(taskFromValues.startDateTime).toISOString(),
          endDateTime:  this.app._saveDateTimeWithZone(taskFromValues.endDateTime).toISOString(),
          locationId: null,
          location: null,
          timeZoneId: null,
          timeZone: null,
          parentTaskId: null,
          statusId: 1,
          status: null,
          reminderTypeId: taskFromValues.reminderTypeId,
          reminderType: this.taskEditDetails?.task?.reminderType,
          isValid: true,
          validFromDate: null,
          validToDate: null,
          taskTypeId: this.taskType == TaskType.Individual ? 1 : 2,
          childTaskOrder: this.taskOrder,
          childTaskList: this.groupAllTaskList?.map((groupTask, index) => ({
            name: taskFromValues?.taskTitle,
            description: groupTask?.description,
            organizationId: this.taskEditDetails.task?.organizationId,
            taskCategoryId: taskFromValues?.taskCategoryId || null,
            taskCategory: null,
            priorityId: taskFromValues?.priorityId,
            startDateTime:  this.timezoneService.saveDateTimeWithZone(groupTask?.startDate).toISOString(),
            endDateTime: this.timezoneService.saveDateTimeWithZone(groupTask?.endDate).toISOString(),
            locationId: null,
            location: null,
            timeZoneId: null,
            timeZone: null,
            parentTaskId: this.taskEditDetails?.taskId,
            statusId: 1,
            status: null,
            reminderTypeId: taskFromValues?.reminderTypeId,
            reminderType: this.taskEditDetails?.task?.reminderType,
            isValid: this.taskEditDetails.task?.isValid,
            validFromDate: null,
            validToDate: null,
            taskTypeId: this.taskType == TaskType.Individual ? 1 : 2,
            childTaskOrder: this.taskOrder,
            reAssignedDate: groupTask?.reAssignedDate,
            reAssignedDescription: groupTask?.reAssignedDescription,
            reAssignedStatus: groupTask?.reAssignedStatus,
            taskUsers: [
              {
                taskId:  groupTask?.taskUsers?.[0]?.taskId ?? 0,
                userId: groupTask?.assignTo?.id ?? 0,
                sharedUserId: null,
                description: null,
                reAssignedUserId:  groupTask?.taskUsers?.[0]?.reAssignedUserId ?? null,
                id:  groupTask?.taskUsers?.[0]?.id ?? 0,
                createdSource: this.taskEditDetails?.createdSource || null,
                updatedSource: null,
                createdBy: this.taskEditDetails?.createdBy || null,
                updatedBy: null,
                createdDate: this.taskEditDetails?.createdDate || null,
                updatedDate: null
              }
            ],
            taskStatuses: null,
            taskCheckLists: this.groupAllTaskList[index]?.groupTaskChecklist?.map((checkList) => ({
              taskId: this.taskEditDetails?.taskId,
              statusId: 1,
              status: null,
              description: checkList?.description,
              isCheck: checkList?.isCheck,
              id: checkList?.id || 0,
              createdSource: checkList?.createdSource || this.taskEditDetails?.createdSource,
              updatedSource: null,
              createdBy: checkList?.createdBy || this.taskEditDetails?.createdBy,
              updatedBy: null,
              createdDate: checkList?.createdDate || this.taskEditDetails?.createdDate,
              updatedDate: null
            })),
            taskCalendarEvents:this.taskEditDetails.task?.taskCalendarEvents?.map((event) => ({
              ...event,
              calendarEvent: {
                ...event.calendarEvent,
                reminderInMinutes: taskFromValues.reminderDelay ?? event.calendarEvent.reminderInMinutes,
                repeatTypeId: taskFromValues.taskRepeat ?? event.calendarEvent.repeatTypeId,
              }
            })) ?? null,
            taskAttachments: null,
            createdByName: groupTask?.createdByName,
            reminderDateTime: groupTask?.reminderDateTime,
            taskStage: null,
            channelName: null,
            moduleName: null,
            associationName: null,
            stageIds: null,
            taskTypeName: null,
            taskOrder: index,
            childTaskList: null,
            id: groupTask?.id,
            createdSource: groupTask?.createdSource,
            updatedSource: null,
            createdBy: groupTask?.createdBy,
            updatedBy: null,
            createdDate: groupTask?.createdDate,
            updatedDate: null,
          })),
          taskUsers: [{
            userId: this.taskEditDetails?.task.taskUsers[0]?.userId,
            sharedUserId: taskFromValues.sharedUsers,
            taskId: this.taskEditDetails?.task.taskUsers[0]?.taskId,
            id: this.taskEditDetails?.task.taskUsers[0]?.id,
            reAssignedUserId :this.taskEditDetails?.task.taskUsers[0]?.reAssignedUserId ?? null,
            createdSource: this.taskEditDetails?.task.taskUsers[0]?.createdSource,
            updatedSource: null,
            createdBy: this.taskEditDetails?.task.taskUsers[0]?.createdBy,
            updatedBy: null,
            createdDate: this.taskEditDetails?.task.taskUsers[0]?.createdDate,
            updatedDate: null,
            description: ''
          }],
          taskStatuses: null,
          taskCheckLists: null,
          taskCalendarEvents: null,
          taskAttachments: taskFromValues?.attachmentLinks?.map((attachment: any, index) => ({
            ...this.taskEditDetails.task.taskAttachments[index],
            attachmentId: attachment.attachmentId || 0,
            attachment: {
              name: attachment.name,
              location: attachment.location,
              sizeInBytes: attachment.sizeInBytes,
              content: attachment?.content,
              statusId: 1
            },
            id: attachment?.id || 0
          })) || null,
          createdByName: null,
          reminderDateTime: null,
          taskStage: null,
          channelName: null,
          moduleName: null,
          associationName: null,
          stageIds: null,
          taskTypeName: null,
          taskOrder: null,
          id: this.taskEditDetails?.taskId,
          createdSource: this.taskEditDetails?.task.createdSource,
          createdBy: this.taskEditDetails?.task.createdBy,
          createdDate: this.taskEditDetails?.task.createdDate,
        },
        channelId: taskFromValues?.channelId || null,
        stageId: null,
        stageName: null,
        statusId: this.taskEditDetails?.statusId,
        stageIds: taskFromValues?.stages ? [taskFromValues?.stages] : null,

        id: this.taskEditDetails?.id,
        createdSource: this.taskEditDetails?.createdSource,
        createdBy: this.taskEditDetails?.createdBy,
        createdDate: this.taskEditDetails?.createdDate,
      };
      return taskEditPayload
    }

    //#endregion I&G all Payload

    //#region AddTaskCategory*
    validateNewTaskCategory() {
      const categoryName = this.addTaskCategoryForm.get('categoryName').value.trim();
      const categoryExists = this.taskCategories.some(category => category.name === categoryName);
      if (categoryExists) {
        this.detailsFormErrors = { categoryName: 'This task category already exists' };
      } else {
        this.detailsFormErrors = null;
      }
    }

    saveNewTaskCategory() {
      if (this.addTaskCategoryForm.invalid) {
        this.formErrorHandler.showErrorOnSubmit();
        this.scrollToError();
        return; //Return if form invalid
      }
      const categoryName = this.addTaskCategoryForm.get('categoryName').value.trim();
      const newCategory = {
        name: categoryName
      }
      this.taskCategoryService.addNewTaskCategoryGet(newCategory).subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner('newTaskCategory');
          this.loadingTaskSave = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'New Task Category Added Successfully'
          });
          this.addTaskCategoryForm.reset();
          this.displayAddTaskCategory = false;
          this.getTaskCategories();
        },
        error: (error) => {
          this.appMainService.isHideSpinner('newTaskCategory');
          this.loadingTaskSave = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:  error.error ?? 'Failed To Create New Task Category'
          });
        }
      })
    }

    cancelNewTaskCategory() {
      this.addTaskCategoryForm.reset();
      this.displayAddTaskCategory = false;
    }

    //#endregion AddTaskCategory*

    //#region *ShowEditDetails*
      populateTaskData(taskId) {
      this.appMainService.isShowSpinner('EditTask');
      this.taskService.getTaskDetailById(taskId).subscribe({
        next: (response) => {
          const editDetails: any = response;
          this.taskEditDetails = response;
          const task = this.taskEditDetails.task
          this.taskType = (this.taskEditDetails.task.taskTypeId == TaskType.Individual || this.taskEditDetails.task.taskTypeId == TaskType.Subtask
          ) ? TaskType.Individual : TaskType.Group;
          this.onTaskTypeChange();
 
          this.appMainService.isHideSpinner('EditTask');
          editDetails.objectTypeId && this.onChangeModule(editDetails.objectTypeId);
          const selectedAssociations = this.taskEditDetails?.task?.associationNames?.map(association => {
            return {
              id: association?.id,
              businessName: association?.businessName
            };
          }) || null;
          this.associationNames = selectedAssociations;
          const selectedUser = this.activeUsers.find(user => user?.id === editDetails.task.taskUsers[0]?.userId) || null;
          const sharedUserIds = editDetails.task.taskUsers[0]?.sharedUserId || [];
          const validSharedUserIds = sharedUserIds.filter(id => 
            this.sharedTaskWith.some(user => user.id === id)
          );
          this.repeat = this.app.eventRepeatType;
          this.taskDetailsForm.patchValue({
            id: this.taskEditDetails?.task?.taskId ?? 0,
            startDateTime: this.app._showDateTimeWithZone(editDetails.task.startDateTime),
            endDateTime: this.app._showDateTimeWithZone(editDetails.task.endDateTime),
            relatedTo: editDetails?.objectTypeId,
            channelId: editDetails?.channelId,
            taskTitle: editDetails.task.name,
            sharedUsers: validSharedUserIds?.length > 0 ? validSharedUserIds : null,
            assignedTo: selectedUser ? [selectedUser] : null,
            priorityId: editDetails.task.priorityId,
            reminderTypeId: editDetails.task.reminderTypeId,
            stages: editDetails?.stageIds?.[0] ?? null,
            association: selectedAssociations,
            reminderDelay: editDetails?.task?.taskCalendarEvents[0]?.calendarEvent?.reminderInMinutes,
            taskRepeat: editDetails?.task?.taskCalendarEvents[0]?.calendarEvent?.repeatTypeId || this.repeat?.[0]?.id,
          })
          this.updateTaskCategory();
          this.patchAttachments(editDetails.task?.taskAttachments);
          
          // editDetails?.channelId && this.onChangeChannel(editDetails?.channelId)
          if (this.taskType == TaskType.Individual) {
            this.loadContentInEditor(task?.description, true);
            const checkListArray = this.taskDetailsForm.get('checklist') as FormArray;
            this.taskEditDetails.task?.taskCheckLists.forEach(item => {
              const checkListGroup = this.formBuilder.group({
                description: [item.description],
                isCheck: [item.isCheck],
                id: [item.id]
              });
              checkListArray.push(checkListGroup);
            });
          } else {
            this.taskOrder = task?.childTaskOrder;
            task?.childTaskList?.forEach(task => {
              const assignedUser = this.activeUsers.find(user => user?.id === task?.taskUsers[0]?.userId); // Find assigned user
              const taskData: any = {
                id: task?.id,
                assignTo: assignedUser,
                startDate: this.app._showDateTimeWithZone(task?.startDateTime),
                endDate:  this.app._showDateTimeWithZone(task?.endDateTime),
                description: task?.description,
                groupTaskChecklist: task?.taskCheckLists,
                taskUsers: task?.taskUsers,
                reAssignedDate: task?.reAssignedDate,
                reAssignedDescription: task?.reAssignedDescription,
                reAssignedStatus: task?.reAssignedStatus,
              }
              this.groupAllTaskList.push(taskData);
            });
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner('EditTask');
          this.loadingTaskSave = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.message : 'Failed To Get the Task Details.'
          });
        }
      })
    }

    loadContentInEditor(text: any, updateSelf: boolean = false) {
      if (updateSelf) {
        this.taskDetailsForm.patchValue({
          taskDetails: text
        })
      }else{
        this.groupTaskDetailsForm.patchValue({
          description : text
        })
      }
      setTimeout(() => {
        const _quill = this.editor.getQuill();
        _quill.clipboard.dangerouslyPasteHTML(text);
      });
    
    }

    patchAttachments(attachments: any[]): void {
      attachments.forEach(attachment => {
        this.attachments.push(this.formBuilder.group({
          attachmentId: attachment.attachmentId,
          name: attachment.attachment.name,
          location: attachment.attachment.location,
          sizeInBytes: attachment.attachment.sizeInBytes,
          id: attachment?.id
        }));

        // Add to uploadedFiles array for display
        this.uploadedFiles.push({
          name: attachment.attachment.name,
          location: attachment.attachment.location,
          sizeInBytes: attachment.attachment.sizeInBytes
        });
      });
    }

    //#endregion *ShowEditDetails*

    //#region **GroupTask*
    initAddGroupTaskDetailsForm(selectedUser?:any) {
      this.detailsFormErrors = {};
      const groupTaskCheckListData = []
      let endDate = new Date(new Date().getTime() + 6 * 24 * 60 * 60 * 1000);
      let startDate = this.app._showDateTimeWithZone(new Date());
      let endDateTime = this.app._showDateTimeWithZone(endDate);
      this.groupTaskDetailsForm = this.formBuilder.group({
        id: [0],
        assignTo: [selectedUser|| null, Validators.required],
        startDate: [startDate],
        endDate: [endDateTime],
        description: [null , Validators.required],
        groupTaskChecklist: [groupTaskCheckListData],
        reAssignedStatus : [false]

      }, { validator: startDateLessThanEndDateValidator('startDate', 'endDate') });
      this.formErrorHandler.handleErrors(this.groupTaskDetailsForm, this.detailsFormErrors, {
        description: {
          required: "Task Details is required",
        },
        assignTo: {
          required: "Assign To is required",
        }
      });
      this.loadContentInEditor(this.groupTaskDetailsForm.value?.description, false);
    }

    addTaskMulti(i?) {
      let selectedUser:any
      if (this.defaultTaskFeildsValues?.assignUserId) {
         selectedUser = this.activeUsers.find(user => user?.id === this.defaultTaskFeildsValues?.assignUserId);
      }else if (this.selectedReassignUser) {
        selectedUser = this.selectedReassignUser[0];
      }
      this.initAddGroupTaskDetailsForm(selectedUser);
      this.checklistHeader2 = "Add Task";
      this.displayGroupTaskList = true;
    }

    editTaskMulti(groupTaskIndex) {
      this.groupTaskIndex = groupTaskIndex
      const groupTask = this.groupAllTaskList[groupTaskIndex];
      this.groupTaskDetailsForm.patchValue({
        id: groupTask.id,
        assignTo: groupTask.assignTo,
        startDate: groupTask.startDate,
        endDate: groupTask.endDate,
        reAssignedStatus: groupTask?.reAssignedStatus
      });
      this.loadContentInEditor(groupTask.description, false);
      this.checklistHeader2 = "Edit Task";
      this.displayGroupTaskList = true;
    }

    saveGroupTaskList() {
      if (this.groupTaskDetailsForm.invalid) {
        this.formErrorHandler.showErrorOnSubmit();
        this.scrollToError();
        if(this.groupTaskDetailsForm?.errors?.isStartDateLessThanEndDate){
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:  'Start Date must be earlier than Due Date.'
          });
        }
        return;   //Return if form invalid
      }
      if (this.groupTaskDetailsForm.valid) {
        let taskData: any = this.groupTaskDetailsForm.value;
        if (this.checklistHeader2 === "Add Task") {
          this.groupAllTaskList.push(taskData);
          this.findDateRange(this.groupAllTaskList);

        }
        else {
          const groupTasK = this.groupAllTaskList[this.groupTaskIndex];
          this.groupAllTaskList[this.groupTaskIndex] = {
            ...groupTasK,
            assignTo: taskData?.assignTo,
            startDate: taskData?.startDate,
            endDate: taskData?.endDate,
            description: taskData?.description,
            reAssignedStatus: taskData?.reAssignedStatus
          };
        }
        this.findDateRange(this.groupAllTaskList);
        // Reset the form after saving

        this.groupTaskDetailsForm.reset();
        this.displayGroupTaskList = false;
      }
    }

    //min & max date
    findDateRange(groupTaskData: any) {
      if (groupTaskData && groupTaskData.length > 0) {
        const startDates = groupTaskData.map(item => new Date(item.startDate));
        const endDates = groupTaskData.map(item => new Date(item.endDate));
        let minDate = new Date(Math.min(...startDates));
        let maxDate = new Date(Math.max(...endDates));
        this.taskDetailsForm.patchValue({
          startDateTime: minDate,
          endDateTime: maxDate,
        })
      }
    }

    //drag & drop
    drop(event: CdkDragDrop<string[]>) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    getTaskFeildsAndDefaultValues() {
      this.appMainService.isShowSpinner('defaultValues');
    
      // Run both API calls in parallel
      forkJoin({
        taskFields: this.taskService.getTaskFeilds(),
        defaultValues: this.taskService.getTaskDefaultValues()
      }).subscribe({
        next: ({ taskFields, defaultValues }) => {
          this.appMainService.isHideSpinner('defaultValues');
    
          // Set task fields response
          this.taskFeildData = taskFields;
    
          // Set default values response
          this.defaultTaskFeildsValues = defaultValues || {};
    
          // Process task fields and default values as needed
          if (this.taskFeildData?.relatedTo && !this.taskFromModule  && this.isAddTask) {
            this.onChangeModule(this.defaultTaskFeildsValues?.objectTypeId);
          }
    
          if (this.defaultTaskFeildsValues && this.isAddTask) {
            const selectedUser = this.activeUsers.find(user => user?.id === this.defaultTaskFeildsValues?.assignUserId) || null;
            const selectedAssociations = this.defaultTaskFeildsValues?.associationNames?.map(association => {
              return {
                id: association?.id,
                businessName: association?.businessName
              };
            }) || null;

            if (this.taskType == TaskType.Individual ) {
              this.taskDetailsForm.patchValue({
                assignedTo: selectedUser ? [selectedUser] : null,
              });
            } else if (this.taskType == TaskType.Group) {
              this.initAddGroupTaskDetailsForm(selectedUser);
            }
    
            if (this.taskFeildData?.relatedTo && !this.taskFromModule && !this.moduleId) {
              this.taskDetailsForm.patchValue({
                relatedTo: this.defaultTaskFeildsValues?.objectTypeId,
                channelId: this.defaultTaskFeildsValues?.channelId,
              });
            }
    
            if (this.taskFeildData?.sharedWithMe) {
              this.taskDetailsForm.patchValue({
                sharedUsers: this.defaultTaskFeildsValues?.sharedUserId
              });
            }
    
            if (!this.taskFromModule && !this.moduleId) {
              this.taskDetailsForm.patchValue({
                association: selectedAssociations,
              });
            }

            if(this.defaultTaskFeildsValues?.priorityId){
              this.taskDetailsForm.patchValue({
                priorityId: this.defaultTaskFeildsValues?.priorityId,
              })
            }
            else{
              const selectedPriority = this.priority && this.priority.length > 0 ? this.priority[0].id : null;
              this.taskDetailsForm.patchValue({
                priorityId: selectedPriority,
              })
            }
            if(this.defaultTaskFeildsValues?.taskCategoryId ){
              this.taskDetailsForm.patchValue({
                taskCategoryId: this.defaultTaskFeildsValues?.taskCategoryId ?? null,
              });
            }
           
          }
          this.defaultTaskFeildsValues?.channelId && this.onChangeChannel(this.defaultTaskFeildsValues?.channelId);
        },
        error: (error) => {
          this.appMainService.isHideSpinner('defaultValues');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.Message ?? 'Failed to get Field Data'
          });
        }
      });
    }

    //#region updateValidators
    onTaskTypeChange() {
      if (this.taskType == TaskType.Individual) {
        this.taskDetailsForm.get('taskDetails').setValidators([Validators.required]);
        this.taskDetailsForm.get('assignedTo').setValidators([Validators.required]);
        this.formErrorHandler.handleErrors(this.taskDetailsForm, this.detailsFormErrors, {
          assignedTo: {
            required: "Task assign-to is required",
          },
          taskDetails: {
            required: "Task Details are required",
          }
        });

      } else if (this.taskType == TaskType.Group) {
        this.taskDetailsForm.get('taskDetails').clearValidators();
        this.taskDetailsForm.get('assignedTo').clearValidators();
      }
      this.taskDetailsForm.get('taskDetails').updateValueAndValidity();
      this.taskDetailsForm.get('assignedTo').updateValueAndValidity();
    }

    //#region manual selection

    //Manuall Selection
    displayManualPopup: boolean = false;
    manualRuleColumnSetttings: Partial<ColumnSettingsN> = {};
    selectedRecordList: any[] = [];
    selectedModule: any;
    selectedChannel: any;

    assignData() {
        if(this.taskDetailsForm.get('relatedTo')?.value && this.taskDetailsForm.get('channelId')?.value && !this.taskFromModule){
            this.selectedModule = this.taskModules.find(c=> c.id==this.taskDetailsForm.get('relatedTo')?.value);
            this.selectedChannel = this.channelsN.find(c=> c.id==this.taskDetailsForm.get('channelId')?.value);
            this.chooseAccountCol();
            const selectedList: any =  JSON.parse(JSON.stringify(this.taskDetailsForm.value.association));
            this.selectedRecordList = this.taskDetailsForm.value.
            association ? [...selectedList] : [];
            this.displayManualPopup = true;

        }
    }

    saveAssignData($event) {
      const selectedList: any =  JSON.parse(JSON.stringify($event.selectedReccords));
      this.selectedRecordList = [...selectedList];
      if (this.selectedRecordList?.length > 0) {
        this.taskDetailsForm.patchValue({
          association: this.selectedRecordList
        });
      }
        this.displayManualPopup = false;
    }


    reseAssociation(association){
      this.selectedRecordList = [...this.taskDetailsForm.value.association]
      this.selectedRecordList = this.selectedRecordList.filter(item => item.id !== association.id);
      this.taskDetailsForm.patchValue({
        association: this.selectedRecordList.length > 0 ? this.selectedRecordList : null
      });
    }

    chooseAccountCol() {
        this.columnSettingsService.getColumnSettings(this.taskDetailsForm.get('relatedTo')?.value, this.taskDetailsForm.get('channelId')?.value).subscribe(
            resp => {
                let defaultColumnSettings: Partial<ColumnSettingsN> = ParseHelper.DeepCopy(resp);
                this.manualRuleColumnSetttings = defaultColumnSettings;
            },
            err => {
            }
        );
    }

    columnSettingSaved($event) {
        this.manualRuleColumnSetttings = $event;
    }

    manualpopupCancelClicked() {
        this.displayManualPopup = false;
    }

    //#endregion manual selection

    //#endregion **GroupTask*

    //#region **FromModules

    clearListboxFilter(listbox: any) {
       listbox.cd.detectChanges();
    }

    getSanitizedTaskDescription(description: string): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(description);
    }

    deleteTask(index: number): void {
      this.confirmationService.confirm({
        message: "Are you sure you want to delete this task?",
        header: "Change Confirmation",
        icon: "pi pi-info-circle",
        key: 'confirmTask',
        accept: () => {
          this.groupAllTaskList.splice(index, 1);
        },
        reject: () => { },
      
    });
  }

  //#region AssignToPopup
  assignUser() {
    this.isAssignToSingleOrMulti = this.taskEditId > 0 || this.taskType == TaskType.Group;
    if (this.taskType == TaskType.Group) {
      const selectedList = JSON.parse(JSON.stringify(this.groupTaskDetailsForm.value?.assignTo));
      this.selectedReassignUser = this.groupTaskDetailsForm.value.assignTo ? selectedList : [];
    } else if (this.taskType == TaskType.Individual) {
      const selectedList: any = JSON.parse(JSON.stringify(this.taskDetailsForm.value?.assignedTo));
      this.selectedReassignUser = this.taskDetailsForm.value.
        assignedTo ? [...selectedList] : [];
    }
    
    this.displayUsers = true;
  }

  saveAssignUser($event) {
    const selectedUser = JSON.parse(JSON.stringify($event.selectedUsers));
    if (this.taskType == TaskType.Group) {
      this.selectedReassignUser = selectedUser ? [...selectedUser] : [];
      if (this.selectedReassignUser?.length > 0) {
        this.groupTaskDetailsForm.patchValue({
          assignTo: this.selectedReassignUser[0]
        });
      }
    } else if (this.taskType == TaskType.Individual) {
      this.selectedReassignUser = selectedUser ? [...selectedUser] : [];
      if (this.selectedReassignUser?.length > 0) {
        this.taskDetailsForm.patchValue({
          assignedTo: this.selectedReassignUser
        });
      }
    }
    this.displayUsers = false;
  }

  assignUserPopupCancelClicked() {
    this.displayUsers = false;
  }

  removeAssignTo(assignTo) {
    const assignedTo = this.taskDetailsForm.value?.assignedTo || [];
    this.selectedReassignUser = assignedTo.filter(item => item?.id !== assignTo?.id);
    this.taskDetailsForm.patchValue({
      assignedTo: this.selectedReassignUser?.length > 0 ? this.selectedReassignUser : null
    });
  }
  //#endregion AssignToPopup
  

  onNotificationSwitchChange(event: any): void {
    const isSwitchChecked = event.checked;
    this.confirmationService.confirm({
      message: isSwitchChecked
        ? "Do you want to enable notification and email restrictions?"
        : "Do you want to disable notification and email restrictions?",
      header: "Confirmation",
      icon: "pi pi-info-circle",
      accept: () => {

      },
      reject: () => {
        this.taskDetailsForm.patchValue({
          restrictNotifications: !isSwitchChecked
        })
      },

    });
  }

    ngOnDestroy(): void {
      if (this.ngUnsubscribe$) {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.ngUnsubscribe$.unsubscribe();
      }
    }
  }
